import { useState, useEffect } from "react";
import { getCardioHealth } from "../../api/api";
import { toast } from "react-toastify";
import { useAppContext } from "../../context/AppContext";
import { useLocation, useNavigate } from "react-router-dom";

export function ProgressBar({ progressPercentage, exerciseName }) {
  //   console.log("progre Bar" + progressPercentage);
  return (
    <div>
      {/* <p className="text-poppins font-light text-xl py-2">{exerciseName}</p> */}
      <p className="text-poppins font-light text-xl py-2">{exerciseName}</p>
      <div className="h-2 w-full bg-[#100F1F] rounded overflow-hidden">
        <div
          style={{ width: `${progressPercentage}%` }}
          className={`${
            progressPercentage <= 25
              ? "bg-[#D13B3B]"
              : progressPercentage <= 65
              ? "bg-[#FFFF00]"
              : "bg-[#C3F73A]"
          } flex items-center justify-center h-full rounded`}
        ></div>
      </div>
    </div>
  );
}

export function CardioResult() {
  console.log("Rendering Cardio Result Page");
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState({});
  const [performanceData, setPerformanceData] = useState([]);

  // getUser Details function
  const getCardio = async () => {
    const baseURL = window.location.href;
    let url = new URL(baseURL);
    let search_params = url.searchParams;
    const id = search_params.get("id");
    const res = await getCardioHealth(id);
    window.dataLayer = window.dataLayer || [];
    (window.dataLayer).push({
      customerFirstName: res?.first_name,
      customerLastName: res?.last_name,
      customerEmail: "",
      customerDOB:res?.dob,
      cutomerCompanyName: "",
      customerPhone: res?.mobile,
      customerBillingAddress1: "",
      customerBillingAddress2: "",
      customerBillingCity: "",
      customerState: "",
      customerBillingPostcode: "",
      customerBillingCountry: "",
      event: "demo_end",
      });
    setUserDetails(res);
    setPerformanceData(res.execises);
  };

  useEffect(() => {
    getCardio();
  }, []);

  return (
    <>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:px-32 px-5 lg:py-10 py-6">
        <div className="grid grid-rows-3 align-middle">
          <div className="py-0">
            <p className="text-lg md:text-xl text-white font-light font-poppins">
              Your Cardiovascular health is
              {/* <span className="text-primary-neonGreen text-2xl md:text-3xl font-medium">
              Cardio Age is
            </span> */}
            </p>
          </div>
          <div className="md:-mt-32 -mt-24">
            <p className="text-3xl md:text-3xl font-medium font-poppins text-primary-neonGreen lg:px-4">
              {userDetails?.cardioHealth}
            </p>
          </div>
          {/* <p className="flex items-center justify-start text-white px-4 lg:py-3 pb-3 rounded-3xl text-xs font-light font-poppins md:text-sm lg:-mt-36 md-mt-24 -mt-52 lg:my-60 my-80 lg:mr-8 md:mr-96 sm:mr-28">
            {userDetails.fitnessAgeText}
          </p> */}
          <div className="text-white text-lg font-poppins font-light h-full md:-mt-60 -mt-44">
            <p className="text-white font-light text-xl">Performance Summary</p>
            <div className="flex flex-col gap-7 pt-6">
              {performanceData?.map((exe) => {
                return (
                  <ProgressBar
                    progressPercentage={exe.percentage}
                    exerciseName={exe.exercise}
                  />
                );
              })}
            </div>
          </div>
        </div>
        {/* <div
          className="sm:hidden sm:-mt-40 lg:mt-0  lg:flex flex-row justify-center items-center col-span-2 mx-6 lg:space-x-2 lg:pr-4 -mt-16"
          // className="grid xl:grid-cols-2  lg:grid-cols-2 md:grid-cols-2 grid-cols-1 px-4 py-2"
        >
          <div className="w-full h-96 background: linear-gradient(300.44deg, #1A1A1F -28.65%, rgba(22, 22, 35, 0.95) 100%) rounded-lg overflow-hidden">
            <iframe
              src={
                "https://api.getactyv.com/v3/human_anatomy?muscleGroup=" +
                userDetails.improvement?.exercise_category +
                "&side=front"
              }
              frameBorder="0"
              className="sm:hidden lg:block w-full h-96 flex items-center justify-center"
              allowFullScreen
              style={{ overflow: "auto", width: "107%" }}
            ></iframe>
          </div>
          <div className="w-full h-96 background: linear-gradient(300.44deg, #1A1A1F -28.65%, rgba(22, 22, 35, 0.95) 100%) rounded-lg overflow-hidden">
            <iframe
              src={
                "https://api.getactyv.com/v3/human_anatomy?muscleGroup=" +
                userDetails.improvement?.exercise_category +
                "&side=back"
              }
              frameBorder="0"
              className="sm:hidden lg:block w-full h-96"
              allowFullScreen
              style={{ overflow: "auto", width: "107%" }}
            ></iframe>
          </div>
        </div> */}
        <div className="flex flex-col lg:pl-16  space-y-10 w-full text-white text-lg font-poppins font-medium md:mt-0 mt-10">
          <p>
            Improvement Areas <br />
            <span className="text-xs">
              {userDetails.improvement?.improvemment_area}
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum
              nulla ex, obcaecati quia saepe unde deserunt veniam labore,
            </span>
          </p>
          <p>
            Here is Why <br />
            <span className="text-xs font-light">
              {userDetails.improvement?.why}
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum
              nulla ex, obcaecati quia saepe unde
            </span>
          </p>
          <p>
            What should you Do <br />
            <span className="text-xs font-light">
              {userDetails.improvement?.what}
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum
              nulla ex, obcaecati quia saepe unde
            </span>
          </p>
          <p>
            How can you Train <br />
            <span className="text-xs font-light">
              {userDetails.improvement?.how}
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum
              nulla ex, obcaecati quia saepe unde
            </span>
          </p>
          <div className="flex justify-end space-y-0">
            <button
              className="text-xs text-white bg-violet-800 font-poppins font-medium rounded-xl px-6 py-4"
              onClick={() => {
                // navigate("/login");
                navigate("/register");
                // window.location.href = "http://localhost:3000/register";
              }}
            >
              Start Free Trial
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
export default CardioResult;
